import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  subTitle: {
    marginBottom: 20,
    fontSize: 14,
    fontWeight: 500,
  },
});
